import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/category/movie",
    label: "电影",
    desc: "院线大片 · 口碑佳片",
    icon: "ri-film-line",
    tone: "primary" as const,
  },
  {
    to: "/category/tv",
    label: "电视剧",
    desc: "热播剧集 · 连续更新",
    icon: "ri-tv-2-line",
    tone: "accent" as const,
  },
  {
    to: "/category/variety",
    label: "综艺",
    desc: "真人秀 · 音乐竞技",
    icon: "ri-mic-line",
    tone: "secondary" as const,
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full px-4 py-10 md:px-6 md:py-12 lg:px-10">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
        {ENTRIES.map((entry) => {
          const iconWrap =
            entry.tone === "accent"
              ? "bg-accent-500/15 text-accent-400"
              : entry.tone === "secondary"
                ? "bg-secondary-500/20 text-secondary-300"
                : "bg-primary-500/15 text-primary-400";
          const badge =
            entry.tone === "accent"
              ? "bg-accent-100 text-accent-900"
              : entry.tone === "secondary"
                ? "bg-secondary-100 text-secondary-900"
                : "bg-primary-100 text-primary-900";
          return (
            <Link
              key={entry.to}
              to={entry.to}
              className="group flex items-center gap-4 rounded-lg border border-background-800 bg-background-900 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/60 md:p-6"
            >
              <span className={`flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-lg ${iconWrap} md:h-16 md:w-16`}>
                <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-lg font-bold text-foreground-50 md:text-xl">{entry.label}</h3>
                  <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${badge}`}>分类</span>
                </div>
                <p className="mt-1 clamp-1 text-xs text-foreground-500 md:text-sm">{entry.desc}</p>
              </div>
              <i className="ri-arrow-right-line text-xl text-foreground-600 transition-all duration-300 group-hover:translate-x-1 group-hover:text-primary-400"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}